export const library = {};
// @todo Warn if override existing key.
export function register(key, component) {
    Object.assign(library, { [key]: component });
}
//# sourceMappingURL=library.js.map